import { Button } from '../components/ui/Button'

type PlaceholderPageProps = {
  title: string
  description: string
}

export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  return (
    <section className="pp-placeholder">
      <div className="pp-container">
        <div className="pp-placeholder__box">
          <span className="pp-badge">Phase 1 checkpoint</span>
          <h1 className="pp-section__title" style={{ marginTop: '1rem', maxWidth: '20ch' }}>
            {title}
          </h1>
          <p>{description}</p>
          <p>
            Full page content will follow after the Home visual checkpoint is approved.
            Existing operational fallbacks remain at <code>/client</code> and{' '}
            <code>/admin</code> on the API host.
          </p>
          <div style={{ marginTop: '1.5rem' }}>
            <Button to="/">Back to Home</Button>
          </div>
        </div>
      </div>
    </section>
  )
}
